module.exports = __webpack_public_path__ + "848211f31b1361228140b941550ddd84.svg";